
import React, {Component} from "react";
import { isElectron } from 'react-device-detect'
import {connect, useSelector} from "react-redux";
import {withRouter} from "react-router-dom";
import { Button, Container } from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faForward, faLifeRing, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import {withTranslation} from "react-i18next";
import preshiftManage from "../../../../reducers/preshift-manager";
import ExitTimer from "../../../blocks/ExitTimer";
import { setLog } from "../../../../helpers/functions";
import configApp from "../../../../config/config";
import VRTrainingStart from "../../../screens/questions/flow/VRtrainingStart";
import VRTrainingProcessed from "../../../screens/questions/flow/VRTrainingProcessed";
import apiVRTraining from "../../../../api/apiVRTraining";
import Loader from "../../../blocks/Loader";
import {pageLoadManageActions as loader} from "../../../../reducers/load";

class VRTrainingContainer extends Component {


    constructor(props) {
            super(props);
            this.state = {
                load: false,
                status: '',                
                event_dt: new Date(),
                can_skip: false,
                devMode: configApp.device_settings?.devMode ? true : false,                
                trainingIsStarted: false,
                trainingIsFinish:false,
                currentTrainingStatus:null,
                trainingId:null,
                loadStatus:false                
            };                    
            this.employeUUID = this.props.user.data.uuid;
            this.appointmentUUID = this.props.appointment? this.props.appointment:null;
            this.flowUUID = this.props.flow_uuid? this.props.flow_uuid:null;
            this.scenario = this.props.stepData.data?this.props.stepData.data.id:null;
            this._isMounted = true;    
        }
    
    handliGetVRTrainingStatus = ()=>{
        if(this.state.trainingId && !this.state.loadStatus){
            this.setState({loadStatus:true});
            apiVRTraining.getStatus(this.state.trainingId).then((res)=>{
                if(res.status===200)
                {
                    this.setState({currentTrainingStatus:res.data.actualStatus});                         
                }
            }).finally(()=>{
                this.setState({loadStatus:false});
            });
        }
    }
    componentWillUnmount = ()=>{
        
        this.props.renderAdditionalButton(null);
    }
    componentDidUpdate = ()=>{        
        if(this.state.trainingIsStarted){
            this.renderButton();        
        }
    }

    handleSaveFlow = ()=>{
        apiVRTraining.finishTraining(this.state.trainingId).then((res)=>{           
            
        }).finally(()=>{           
        });
         let statePreshift = this.props.preshift;
            let datumUhrzeit = new Date(),
                event_end_dt = "@" + Math.round(datumUhrzeit.getTime() / 1000),
                stepUuid = this.props.stepData.uuid,
                stepName = this.props.stepData.name,
                start_time = '@' + Math.round(this.state.event_dt.getTime() / 1000),
                finalStatus = this.state.currentTrainingStatus??null,
                vrTrainingId = this.state.trainingId,
                data = {
                    uuid: stepUuid,
                    name: stepName,
                    start_date_time: start_time,
                    elapsed_time: event_end_dt,
                    finalTrainingStatus: finalStatus,
                    trainingId: vrTrainingId                    
                },
                flow_history = statePreshift.flow.history.steps;
                flow_history.push(data);
        
    }
    
    handleInitVRTraining = ()=>{
        loader.start('vr_training_started');        
            this.setState({load:true});
            try{
        apiVRTraining.initTraining(this.employeUUID,this.appointmentUUID,this.flowUUID,this.scenario)
                .then((res)=>{                    
                    if(res.status === 200) 
                    {
                        this.setState(
                            {
                                currentTrainingStatus:res.data.actualStatus,
                                trainingId:res.data.id,
                                trainingIsStarted:true
                            });
                    }
                    
                })
                .catch((res)=>{
                    
                }) //* игнорируем
                .finally(async (result) => {                    
                    loader.stop('vr_training_started');                    
                    this.setState({load:false});       
                                
                });                        
            }catch(e)
            {
                loader.stop('vr_training_started');
                console.log(e);
            }
    }

   renderButton = () => {
            
           let came_from = preshiftManage.getCameFrom();
           if (came_from !== 'startup' && this.props.activeStep === this.props.listEducation[this.props.activeEducation].listStep.length - 1 &&
               this.props.activeEducation === this.props.listEducation.length - 1) {
                   this.props.renderAdditionalButton(
                       <div className="d-flex w-100 justify-content-end">                            
                           <Button className="MuiButton Btn Btn_success"
                                   onClick={() => {
                                            this.handleSaveFlow();
                                           this.props.handleNextStep();
                                           this.props.renderAdditionalButton(null); }}>
                               <FontAwesomeIcon className="mr-4" icon={faForward}/>
                               {this.props.t('Done')}
                               {this.state.isWatched && came_from === "electronic-courses" &&
                                   <ExitTimer theme_name={this.props.app.theme_name} goOut={this.props.handleNextStep} handleExitTimer={this.handleExitTimer}/>}
                           </Button>
                           {came_from !== "electronic-courses" &&
                               <Button className="MuiButton Btn Btn_success ml-3"
                                       onClick={() => {                  
                                                this.handleSaveFlow();                         
                                               this.props.handleFinish();
                                               this.props.renderAdditionalButton(null); }}>
                                   <FontAwesomeIcon className="mr-4" icon={faForward}/>
                                   {this.props.t('Finish and exit')}
                                   {this.state.isWatched && <ExitTimer theme_name={this.props.app.theme_name} goOut={this.props.handleFinish} handleExitTimer={this.handleExitTimer}/>}
                               </Button>}
                       </div>);
           } else {
               this.props.renderAdditionalButton(
                   <div className="d-flex w-100 justify-content-end">                    
                       <Button className="MuiButton Btn Btn_success"
                               onClick={() => {
                                       this.handleSaveFlow();
                                       this.props.handleNextStep();
                                       this.props.renderAdditionalButton(null); }}>
                           <FontAwesomeIcon className="mr-4" icon={faForward}/>
                           {this.props.activeStep !== this.props.listEducation[this.props.activeEducation].listStep.length - 1 ?
                                   this.props.t('Next') :
                                   (this.props.activeEducation !== this.props.listEducation.length - 1) ?
                                       this.props.t('Proceed') : this.props.t('Finish and exit')}
                           {((this.props.activeStep === this.props.listEducation[this.props.activeEducation].listStep.length - 1) &&
                           (this.props.activeEducation === this.props.listEducation.length - 1))
                               ? this.state.isWatched && <ExitTimer theme_name={this.props.app.theme_name} goOut={this.props.handleFinish} handleExitTimer={this.handleExitTimer}/>
                               : this.state.isWatched && <ExitTimer theme_name={this.props.app.theme_name} goOut={this.props.handleNextStep} handleExitTimer={this.handleExitTimer}/>}
                       </Button>
                   </div>);
           }
       };
   
    render = () => {
        let  Content = null;
        
        if(!this.state.trainingIsStarted){
             Content = <VRTrainingStart {...this.props}
                            {...this.state} 
                            handleInitVRTraining={this.handleInitVRTraining}
                        />;
        }else{
            Content = <VRTrainingProcessed {...this.props}
            {...this.state}
            currentTrainingStatus = {this.state.currentTrainingStatus}
            handleCheckActualStatus = {this.handliGetVRTrainingStatus}
            loadStatus= {this.state.loadStatus}
            />
        }

        
        return <Container className='d-flex flex-column justify-content-center align-items-center h-100'>
                    <Loader isLoading={this.state.load} loadId={"vr_training_started"} justifyContent="center">
                            {Content}
                    </Loader>
                </Container>
    }
}
const mapStateToProps = (store) => {
    return {
        load: store.loadState,
        preshift: store.preshiftState,
    }
};
export default connect(mapStateToProps)(withRouter(withTranslation()(VRTrainingContainer)));